import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowRequestTypes } from '../models/requests/enums/WorkflowRequestTypes.enum';
import { ChartHelpers } from '../helpers/chartHelpers';

@Pipe({
    name: 'mapWorkflowTypeToColor',
    standalone: true
})
export class MapWorkflowTypeToColor implements PipeTransform {

    transform(value: string): string {

        return ChartHelpers.getBrandColorByWorkflowRequestType(value as WorkflowRequestTypes);
    }
}
